import { TranslationProcessedValue } from '.';
import { RESOLVE, RESOLVE_FAILURE, RESOLVE_SUCCESS } from './translation.actionTypes';

export const actionCreators = {
	doResolveTranslation: (value: string, languages: string[] = ['de', 'fr', ' it']) => ({
		type: RESOLVE,
		languages,
		value,
	}),
	doResolveTranslationFailure: (error?: Error) => ({
		type: RESOLVE_FAILURE,
		error,
	}),
	doResolveTranslationSuccess: (translations: TranslationProcessedValue) => ({
		type: RESOLVE_SUCCESS,
		translations,
	}),
};

export type TranslationActionType =
	| ReturnType<typeof actionCreators.doResolveTranslation>
	| ReturnType<typeof actionCreators.doResolveTranslationFailure>
	| ReturnType<typeof actionCreators.doResolveTranslationSuccess>;
